import { Box } from "@mantine/core";
import { EksempelGenerelInfo } from "./EksempelGenerelInfo";
import { EksempelKapitler } from "./EksempelKapitler";

export const EksempelRapport: React.FC = () => {
  return (
    <Box>
      <EksempelGenerelInfo />
      <EksempelKapitler />
    </Box>
  );
};
